import store from '@/store/store';
import { ioListOptions, ioSaveOption } from '@/febos/servicios/api/herramientas.api';
import { ioMaterialRequestSearch } from '@/febos/servicios/api/busqueda.api';
import {
  ioCreateMaterial,
  ioCreateMaterialRequest,
  ioGetMaterialDetail,
  ioSetMaterial,
  ioSetCatalog,
  ioGetMaterialRequestDetail
} from '@/febos/servicios/api/customDocuments.api';
import {
  listV2Options,
  listV2OptionsUsers,
  deleteOptionUser,
  updateOptionsUsers
} from '@/febos/servicios/api/opciones.api';

export default {
  async addNewMaterial({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCreateMaterial('productos', payload);
      store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async editMaterial({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      const response = await ioSetMaterial('productos', payload.id, payload.query);
      store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async addNewCatalog({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      console.log('addNewCatalog 2', payload);
      const response = await ioCreateMaterial('catalogos', payload);
      store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async editCatalog({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      const response = await ioSetCatalog('catalogos', payload.id, payload.query);
      store.commit('Modals/CLOSE_MODAL');
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async loadListMaterial({ commit }, data) {
    try {
      commit('SET_LOADING', true);
      const response = await ioGetMaterialDetail('productos', data);
      commit('SET_LIST_MATERIALS', response.data);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async loadMaterialRequestDetail({ commit }, data) {
    try {
      commit('SET_LOADING', true);
      const response = await ioGetMaterialRequestDetail('solicitud_material', data.id, data);
      commit('SET_MATERIAL_REQUEST_DETAIL', response.data.document);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async loadListCatalogs({ commit }, data) {
    try {
      commit('SET_LOADING', true);
      const response = await ioGetMaterialDetail('catalogos', data);
      commit('SET_LIST_CATALOGS', response.data.documents);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async loadListMaterialsRequests({ commit }, data) {
    try {
      commit('SET_LOADING', true);
      const response = await ioGetMaterialDetail('solicitud_material', data);
      commit('SET_LIST_MATERIALS_REQUESTS', response.data);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async loadListMaterialRequest({ commit }, data) {
    try {
      commit('SET_LOADING', true);
      const response = await ioMaterialRequestSearch(data);
      commit('SET_LIST_MATERIALS_REQUESTS', response.data);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async addMaterialRequest({ commit }, payload) {
    try {
      commit('SET_LOADING', true);
      const response = await ioCreateMaterialRequest('solicitud_material', payload, { numerar: 'si' });
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async loadListCategory({ commit }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioListOptions({
        grupoOpcion: 'io.articulos.categorias',
        filtros: 'deshabilitado:0'
      });
      const { opciones } = response.data;
      commit('SET_LIST_CATEGORYS', opciones);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async loadListBrand({ commit }) {
    try {
      commit('SET_LOADING', true);
      const response = await ioListOptions({
        grupoOpcion: 'io.articulos.marcas',
        filtros: 'deshabilitado:0'
      });
      const { opciones } = response.data;
      commit('SET_LIST_BRANDS', opciones);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async setLoading({ commit }, { loading }) {
    commit('SET_LOADING', loading);
  },
  async getOptionUsers({ commit }, payload = {}) {
    commit('SET_LOADING', true);
    try {
      const response = await listV2OptionsUsers(payload);
      const data = response.data.relaciones.map((item) => ({
        optionId: item.opcionId,
        id: item.usuario.id,
        name: item.usuario.nombre,
        email: item.usuario.correo
      }));
      commit('SET_OPTION_USERS', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async removeOptionUser({ commit }, { id, userId, user }) {
    commit('SET_LOADING', true);
    try {
      const response = await deleteOptionUser({
        id,
        usuario_id: userId
      });
      commit('REMOVE_OPTION_USERS', user);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async addUserToOption({ commit }, { body }) {
    commit('SET_LOADING', true);
    try {
      const response = await updateOptionsUsers({
        id: body.optionId,
        usuarios: body.usuarios
      });
      commit('ADD_OPTION_USER', body.user);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async addEntity({ commit }, body) {
    commit('SET_LOADING', true);
    try {
      const param = {
        global: 'si'
      };
      const response = await ioSaveOption(param, body);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async editEntity({ commit }, body) {
    commit('SET_LOADING', true);
    try {
      const param = {
        global: 'si',
        id: body.opcionId
      };
      const response = await ioSaveOption(param, body);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async updateOptionTreeEntities({ commit }, options = []) {
    try {
      commit('SET_ENTITIES', options);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getServices({ commit }, payload = {}) {
    commit('SET_LOADING', true);
    try {
      const response = await listV2Options(payload);
      commit('SET_SERVICES', response.data.opciones);
    } finally {
      commit('SET_LOADING', false);
    }
  },
};
